module.exports = __webpack_public_path__ + "assets/img/guide.e75f97ce.jpg";